export const getAllTaxInspector = (obj) => ({
    type: "GET_ALL_TAX_INSPECTOR",
    obj,
});

export const getAllTaxInspectorSuccess = (data) => ({
    type: "GET_ALL_TAX_INSPECTOR_SUCCESS",
    data,
});

export const getAllTaxInspectorFail = (error) => ({
    type: "GET_ALL_TAX_INSPECTOR_FAIL",
    error,
});


export const addTaxInspector = (obj) => ({
    type: "ADD_TAX_INSPECTOR",
    obj,
});

export const addTaxInspectorSuccess = (data) => ({
    type: "ADD_TAX_INSPECTOR_SUCCESS",
    data,
});

export const addTaxInspectorFail = (error) => ({
    type: "ADD_TAX_INSPECTOR_FAIL",
    error,
});


export const resetAddTaxInspector = (error) => ({
    type: "RESET_ADD_TAX_INSPECTOR",
    error,
});


export const getTIOfDistrict = (obj) => ({
    type: "GET_TI_OF_DISTRICT",
    obj,
});

export const getTIOfDistrictSuccess = (data) => ({
    type: "GET_TI_OF_DISTRICT_SUCCESS",
    data,
});

export const getTIOfDistrictFail = (error) => ({
    type: "GET_TI_OF_DISTRICT_FAIL",
    error,
});

export const updateTI = (obj) => ({
    type: "UPDATE_TI",
    obj,
});

export const updateTISuccess = (data) => ({
    type: "UPDATE_TI_SUCCESS",
    data,
});

export const updateTIFail = (error) => ({
    type: "UPDATE_TI_FAIL",
    error,
});

export const resetUpdateTI = () => ({
    type: "RESET_UPDATE_TI",
});
